export default function authCustomHeader(token) {
  if (token) {
    // For Spring Boot back-end
    // return { Authorization: "Bearer " + user.accessToken };

    // for Node.js Express back-end
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      Url: window.location.href,
    };
  } else {
    return {};
  }
}
